// import React, { useEffect, useState } from 'react';
// import { FaMoneyBill, FaCreditCard, FaHandHoldingUsd, FaFingerprint } from "react-icons/fa";
// import { GiTalk, GiMoneyStack, GiCash, GiReceiveMoney, GiPayMoney } from 'react-icons/gi';
// import { Empty, Spin } from 'antd';

// export const ShowTrans = ({ dasboradData }) => {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(true);

//     // Initial data structure with icons
//     const getInitialCardStructure = (type) => {
//         const iconMap = {
//             'DMT': <GiTalk style={{ fontSize: '26px' }} />,
//             'Cash Deposit': <GiMoneyStack style={{ fontSize: '26px' }} />,
//             'Cash Withdrew': <GiCash style={{ fontSize: '26px' }} />,
//             'Adhaar Pay': <GiReceiveMoney style={{ fontSize: '26px' }} />,
//             'CMS': <GiPayMoney style={{ fontSize: '26px' }} />,
//             'Payment Request': <FaMoneyBill style={{ fontSize: '26px' }} />,
//             'Payout': <FaHandHoldingUsd style={{ fontSize: '26px' }} />,
//             'Quick Dhan': <FaCreditCard style={{ fontSize: '26px' }} />,
//         };

//         return {
//             type,
//             bgColor: '#e3f2fd',
//             isopen: false,
//             icon: iconMap[type] || <GiTalk style={{ fontSize: '26px' }} />,
//         };
//     };

//     useEffect(() => {
//         setLoading(true);
//         if (dasboradData) {
//             try {
//                 const mappedData = [
//                     {
//                         ...getInitialCardStructure('DMT'),
//                         ...dasboradData.dmt,
//                         totalAmount: formatAmount(dasboradData.dmt?.totalAmount),
//                         success: formatTransactionCount(dasboradData.dmt?.success),
//                         failed: formatTransactionCount(dasboradData.dmt?.failed),
//                         pending: formatTransactionCount(dasboradData.dmt?.pending),
//                     },
//                     {
//                         ...getInitialCardStructure('Cash Deposit'),
//                         ...dasboradData.CashDeposit,
//                         totalAmount: formatAmount(dasboradData.CashDeposit?.totalAmount),
//                         approved: formatTransactionCount(dasboradData.CashDeposit?.approved),
//                         rejected: formatTransactionCount(dasboradData.CashDeposit?.rejected),
//                         pending: formatTransactionCount(dasboradData.CashDeposit?.pending),
//                     },
//                     {
//                         ...getInitialCardStructure('Cash Withdrew'),
//                         ...dasboradData.CashWithdrew,
//                         totalAmount: formatAmount(dasboradData.CashWithdrew?.totalAmount),
//                         approved: formatTransactionCount(dasboradData.CashWithdrew?.approved),
//                         rejected: formatTransactionCount(dasboradData.CashWithdrew?.rejected),
//                         pending: formatTransactionCount(dasboradData.CashWithdrew?.pending),
//                     },
//                     {
//                         ...getInitialCardStructure('Adhaar Pay'),
//                         ...dasboradData.adhaarPay,
//                         totalAmount: formatAmount(dasboradData.adhaarPay?.totalAmount),
//                         success: formatTransactionCount(dasboradData.adhaarPay?.success),
//                         failed: formatTransactionCount(dasboradData.adhaarPay?.failed),
//                         pending: formatTransactionCount(dasboradData.adhaarPay?.pending),
//                     },
//                     {
//                         ...getInitialCardStructure('CMS'),
//                         ...dasboradData.cms,
//                         totalAmount: formatAmount(dasboradData.cms?.totalAmount),
//                         success: formatTransactionCount(dasboradData.cms?.success),
//                         failed: formatTransactionCount(dasboradData.cms?.failed),
//                         pending: formatTransactionCount(dasboradData.cms?.pending),
//                     },
//                     {
//                         ...getInitialCardStructure('Payment Request'),
//                         ...dasboradData.paymentRequest,
//                         totalAmount: formatAmount(dasboradData.paymentRequest?.totalAmount),
//                         success: formatTransactionCount(dasboradData.paymentRequest?.success),
//                         failed: formatTransactionCount(dasboradData.paymentRequest?.failed),
//                         pending: formatTransactionCount(dasboradData.paymentRequest?.pending),
//                     },
//                     {
//                         ...getInitialCardStructure('Payout'),
//                         ...dasboradData.payout,
//                         totalAmount: formatAmount(dasboradData.payout?.totalAmount),
//                         success: formatTransactionCount(dasboradData.payout?.success),
//                         failed: formatTransactionCount(dasboradData.payout?.failed),
//                         pending: formatTransactionCount(dasboradData.payout?.pending),
//                     },
//                     {
//                         ...getInitialCardStructure('Quick Dhan'),
//                         ...dasboradData.quickDhan,
//                         totalAmount: formatAmount(dasboradData.quickDhan?.totalAmount),
//                         success: formatTransactionCount(dasboradData.quickDhan?.success),
//                         failed: formatTransactionCount(dasboradData.quickDhan?.failed),
//                         pending: formatTransactionCount(dasboradData.quickDhan?.pending),
//                     },
//                 ];

//                 setData(mappedData.filter(item => item.totalAmount !== '0')); // Filter out items with 0 total amount
//             } catch (error) {
//                 console.error('Error processing dashboard data:', error);
//                 setData([]);
//             }
//         }
//         setLoading(false);
//     }, [dasboradData]);

//     // Format amount with commas and ₹ symbol
//     const formatAmount = (amount) => {
//         if (!amount) return '0';
//         return `${Number(amount).toLocaleString('en-IN', {
//             maximumFractionDigits: 2,
//             minimumFractionDigits: 2
//         })}`;
//     };

//     // Format transaction count
//     const formatTransactionCount = (count) => {
//         if (!count) return '0';
//         return count.toString();
//     };

//     const [visibleCards, setVisibleCards] = useState(5);

//     const toggleCardContent = (index) => {
//         setData(data.map((item, i) => ({
//             ...item,
//             isopen: i === index ? !item.isopen : item.isopen
//         })));
//     };

//     const showMoreCards = () => {
//         setVisibleCards(prev => Math.min(prev + 3, data.length));
//     };

//     if (loading) {
//         return (
//             <div style={{ textAlign: 'center', padding: '50px' }}>
//                 <Spin size="large" />
//             </div>
//         );
//     }

//     if (!data || data.length === 0) {
//         return (
//             <Empty
//                 description="No transaction data available for the selected date"
//                 image={Empty.PRESENTED_IMAGE_SIMPLE}
//             />
//         );
//     }

//     return (
//         <div className="container">
//             {data.slice(0, visibleCards).map((item, index) => (
//                 <div key={index} className="card" style={{ backgroundColor: item.bgColor, cursor: "pointer" }}>
//                     <div className="card-header" onClick={() => toggleCardContent(index)}>
//                         <div>{item.icon}</div>
//                         <div>{item.type}</div>
//                         <div>{item.isopen ? "-" : "+"}</div>
//                     </div>
//                     <div className='card-content' style={{ margin: "10px 0" }}>
//                         <span>Total Transactions: </span>
//                         <span>₹ {item.totalAmount}</span>
//                     </div>
//                     {item.isopen && (
//                         <div className="card-content">
//                             <div>
//                                 Total Success: <span>₹ {item.success || item.approved || '0'}</span>
//                             </div>
//                             <div>
//                                 Total Failed: <span>₹ {item.failed || item.rejected || '0'}</span>
//                             </div>
//                             <div>
//                                 Total Pending: <span>₹ {item.pending || '0'}</span>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             ))}
//             {visibleCards < data.length && (
//                 <div className="show-more" onClick={showMoreCards}>
//                     Show More
//                 </div>
//             )}
//         </div>
//     );
// };


import React, { useEffect, useState } from 'react';
import { Form, DatePicker, Button, Card, Col } from 'antd';
import { FaMoneyBill, FaCreditCard, FaHandHoldingUsd, FaFingerprint } from "react-icons/fa";
import { GiTalk, GiMoneyStack, GiCash, GiReceiveMoney, GiPayMoney } from 'react-icons/gi';
import { DashboardGet } from '../../api/login/Login';
import dayjs from 'dayjs';

export const ShowTrans = ({ initialDashboardData }) => {
    console.log("initialDashboardData",initialDashboardData)
   
    const [data, setData] = useState([]);
    const [visibleCards, setVisibleCards] = useState(5);
    const [startDate, setStartDate] = useState(null);
    const [currentData, setCurrentData] = useState(initialDashboardData);
     const today = dayjs();

    // Format date consistently
    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    };

    // Handle search with filter
    const handleSearch = async () => {
        const dates = today?.format('YYYY-MM-DD') ;
        
        try {
            const formattedDate = formatDate(startDate);
            const response = await DashboardGet({ to: dates , form : dates });
            if (response?.data) {
                setCurrentData(response.data);
            }
        } catch (error) {
            console.error('Failed to fetch filtered data:', error);
        }
    };

    // Clear filter and restore initial data
    const handleClearDates = async () => {
        setStartDate(null)
        try {
            const response = await DashboardGet({data:''});
            if (response?.data) {
                setCurrentData(response.data);
            }
        } catch (error) {
            console.error('Failed to fetch filtered data:', error);
        }
    };
    

    // Disable future dates in DatePicker
    const disableFutureDate = (current) => {
        return current && current > new Date();
    };

    // Transform dashboard data into display format
    const transformDashboardData = (dashboardData) => {
        if (!dashboardData) return [];
        
        return [
            {
                ...dashboardData.dmt,
                type: 'DMT',
                bgColor: '#e3f2fd',
                isopen: false,
                icon: <GiTalk style={{ fontSize: '26px' }} />,
            },
            {
                ...dashboardData.CashDeposit,
                type: 'Cash Deposit',
                bgColor: '#e3f2fd',
                isopen: false,
                icon: <GiMoneyStack style={{ fontSize: '26px' }} />,
            },
            {
                ...dashboardData.CashWithdrew,
                type: 'Cash Withdrew',
                bgColor: '#e3f2fd',
                isopen: false,
                icon: <GiCash style={{ fontSize: '26px' }} />,
            },
            {
                ...dashboardData.adhaarPay,
                type: 'Adhaar Pay',
                isopen: false,
                bgColor: '#e3f2fd',
                icon: <GiReceiveMoney style={{ fontSize: '26px' }} />,
            },
            {
                ...dashboardData.cms,
                type: 'CMS',
                isopen: false,
                bgColor: '#e3f2fd',
                icon: <GiPayMoney style={{ fontSize: '26px' }} />,
            },
            {
                ...dashboardData.paymentRequest,
                type: 'Payment Request',
                bgColor: '#e3f2fd',
                isopen: false,
                icon: <GiTalk style={{ fontSize: '26px' }} />,
            },
            {
                ...dashboardData.payout,
                type: 'Payout',
                bgColor: '#e3f2fd',
                isopen: false,
                icon: <GiMoneyStack style={{ fontSize: '26px' }} />,
            },
            {
                ...dashboardData.quickDhan,
                type: 'Quick Dhan',
                isopen: false,
                bgColor: '#e3f2fd',
                icon: <GiCash style={{ fontSize: '26px' }} />,
            }
        ];
    };

    // Update data when currentData changes
    useEffect(() => {
        const transformedData = transformDashboardData(currentData);
        setData(transformedData);
    }, [currentData]);

    // Initialize with props data
    useEffect(() => {
        setCurrentData(initialDashboardData);
    }, [initialDashboardData]);

    const toggleCardContent = (index) => {
        setData(prevData => 
            prevData.map((item, i) => 
                i === index ? { ...item, isopen: !item.isopen } : item
            )
        );
    };

    const showMoreCards = () => {
        setVisibleCards(prevState => prevState + 2);
    };

    return (
        <>
            <Col span={24}>
                <Card className="shadow-sm" style={{ borderRadius: '10px', marginBottom: '20px' }}>
                    <Form layout="inline">
                        <Form.Item label="Select Date">
                            <DatePicker
                                value={startDate}
                                onChange={(date) => setStartDate(date)}
                                disabledDate={disableFutureDate}
                            />
                        </Form.Item>
                        
                        <Form.Item>
                            <Button type="primary" onClick={handleSearch}>
                                Search
                            </Button>
                        </Form.Item>
                        <Form.Item>
                            <Button onClick={handleClearDates}>
                                Clear Dates
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Col>

            <div className="container">
                {data.slice(0, visibleCards).map((item, index) => (
                    <div key={index} className="card" style={{ backgroundColor: item.bgColor, cursor: "pointer" }}>
                        <div className="card-header" onClick={() => toggleCardContent(index)}>
                            <div>{item.icon}</div>
                            <div>{item.type}</div>
                            <div>{item?.isopen ? "-" : "+"}</div>
                        </div>
                        <div className='card-content' style={{ margin: "10px 0" }}>
                            <span>Total Transactions:</span> 
                            <span>{item.totalAmount}</span>
                        </div>
                        {item?.isopen && (
                            <div className="card-content">
                                <div>Total Success: <span>{item?.success ?? item?.approved ?? 0}</span></div>
                                <div>Total Failed: <span>{item?.failed ?? item?.rejected ?? 0}</span></div>
                                <div>Total Pending: <span>{item?.pending ?? 0}</span></div>
                            </div>
                        )}
                    </div>
                ))}
                {visibleCards < data.length && (
                    <div className="show-more" onClick={showMoreCards}>Show More</div>
                )}
            </div>
        </>
    );
};

